import {
  base_colorContentBorder,
  grey150,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { font_family_weight_regular } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  width: var(--avatar-size);
  height: var(--avatar-size);
  min-width: var(--avatar-size);
  min-height: var(--avatar-size);
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  background-color: ${grey150};
  color: ${text_colorTextSecondary};
  font-family: ${font_family_weight_regular};

  &.outlined {
    border: 1px solid ${base_colorContentBorder};
    background-color: ${grey150};
  }

  & .image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: inherit;

    &.hidden {
      display: none;
    }
  }

  & .fallback {
    width: 100%;
    height: 100%;
    margin: 25%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: inherit;

    &.hidden {
      display: none;
    }

    svg {
      width: 100%;
      height: 100%;
    }
  }

  & .fallback-text {
    // TODO: this looks aesthetically nice and matches current TextAvatar, but isn't really on design system
    //       to keep us unblocked, just using this but we should make discrete size variants
    font-size: calc(var(--avatar-size, 48px) * 0.4);
  }
`
